/* eslint-disable react/jsx-pascal-case */

import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ExplenationFotoForTractable } from "../components/foto-danno-veicolo/ExplenationFotoForTractable";
import { RealtimeModal } from "../components/modal/RealtimeModal";
import { NextButton, SecondChoiseButton } from "../components/styled/Button.style";
import { Section } from "../components/styled/Containers.style";
import { Vspace } from "../components/styled/Separators.style";
import { PageTitle, TextDefault } from "../components/styled/Text.style";
import Trtc_ZoneUrtoCmp from "../components/zone-urto-trtc/Trtc_ZoneUrtoCmp";
import { PATHS } from "../routes/CaiExperienceRouter";
import { selectCommunicationData } from "../store";
import { saveCommunicationAct } from "../store/communication-data/actions";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { TrctProposePhotosQuestionEnum } from "../types/commonTypes";
import { CommunicationType, ZoneUrtoType } from "../types/communication/communicationDataType";
import { composeUrl, tqPageView } from "../utils/utils";
import PageContainerCmp from "./PageContainerCmp";

/* istanbul ignore next */
const Trct_CtpZoneUrtoVeicoloPage = (props: any) => {

    const { isMainImpactPoint } = props;
    const dispatch = useAppDispatch();
    let navigate = useNavigate();
    let { token } = useParams();

    const communicationData = useAppSelector(selectCommunicationData)
    const { communication, ctp } = communicationData
    const [zoneUrto, setZoneUrto] = useState<ZoneUrtoType[]>([])
    const zoneUrtoValid = useMemo(() => zoneUrto.length > 0, [zoneUrto.length])
    const nextBtnDisabled = !zoneUrtoValid;

    const [showModal, setShowModal] = useState(false)

    // Configurazione della pagina basata sul tipo di selezione per il veicolo della controparte
    const pageConfig = useMemo(() => {
        const configs = {
            mainImpact: {
                routePath: PATHS.TRCT_CTP_MAIN_ZONE_URTO_VEICOLO,
                nextStepPath: PATHS.TRCT_CTP_ZONE_URTO_VEICOLO,
                title: "Seleziona il punto d'impatto principale sul veicolo della controparte",
                description: "Cliccando sui bottoni puoi aggiungere/rimuovere il punto d'impatto principale. L'eventuale area già evidenziata è stata rilevata dalla black box."
            },
            additionalZones: {
                routePath: PATHS.TRCT_CTP_ZONE_URTO_VEICOLO,
                nextStepPath: PATHS.TRCT_FOTO_DANNO_TUO_VEICOLO,
                title: "Aggiungi ulteriori zone danneggiate del veicolo della controparte",
                description: "Cliccando sui bottoni puoi aggiungere/rimuovere zone di urto. Le eventuali aree già evidenziate sono rilevate dalla black box."
            }
        };

        return isMainImpactPoint ? configs.mainImpact : configs.additionalZones;
    }, [isMainImpactPoint]);

    const getNextStepPath = (trctProposePhotosQuestion?: TrctProposePhotosQuestionEnum): string => {
        if (!isMainImpactPoint && trctProposePhotosQuestion === TrctProposePhotosQuestionEnum.SKIP_PHOTOS_FLOW) {
            return PATHS.CAI_FILLING_CONDUCENTE;
        }
        return pageConfig.nextStepPath;
    };

    /* istanbul ignore next */
    const goToNextStepHandler = (_trctProposePhotosQuestion?: TrctProposePhotosQuestionEnum) => {
        const nextStepPath = getNextStepPath(_trctProposePhotosQuestion);
        dispatch(saveCommunicationAct({
            data: new CommunicationType({
                ...communication,
                ctp_zoneUrto: isMainImpactPoint ? communication.ctp_zoneUrto.filter(el => el.position !== communication.ctpImpactPoint) : zoneUrto,
                ctpImpactPoint: isMainImpactPoint ? zoneUrto[0].position : communication.ctpImpactPoint,
                trctProposePhotosQuestion: _trctProposePhotosQuestion
            }),
            callback: () => navigate(composeUrl(token, nextStepPath))
        }));
    };

    const proceedWithPhotoHandler = () => {
        goToNextStepHandler(TrctProposePhotosQuestionEnum.TAKE_ADDITIONAL_PHOTOS)
    }

    const skipPhotoHandler = () => {
        goToNextStepHandler(TrctProposePhotosQuestionEnum.SKIP_PHOTOS_FLOW)
    }

    // Inizializzazione delle zone d'urto per il veicolo della controparte
    const initializeCtpZoneUrto = () => {
        if (isMainImpactPoint === undefined) return [];

        if (isMainImpactPoint) {
            // Pagina del punto principale: cerca ctpImpactPoint o ctp.main_impact_point
            const impactPosition = (communication as any).ctpImpactPoint || ctp.main_impact_point;
            return impactPosition ? [new ZoneUrtoType({ position: impactPosition, isSelected: true })] : [];
        } else {
            // Pagina delle zone aggiuntive: usa le zone esistenti della controparte
            return communication.ctp_zoneUrto || [];
        }
    };

    useEffect(() => {
        const initialZones = initializeCtpZoneUrto();
        setZoneUrto(initialZones);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMainImpactPoint, (communication as any).ctpImpactPoint, ctp.main_impact_point, communication.ctp_zoneUrto]);

    const clickGoNextHandler = (value?: boolean) => {
        if (value === false) setZoneUrto([])
        setShowModal(true)
    }

    const onOpenHandler = () => {
        // Analytics
        tqPageView('cai:raccolta foto:foto aggiuntive')
    }



    return (
        <>
            <RealtimeModal
                onOpenHandler={onOpenHandler}
                modalOpened={showModal}
                hTitle=""
                hCloseButton={true}
                onCloseHandler={() => setShowModal(false)}
                onConfirmHandler={() => setShowModal(false)}
                bodyClassName="trct-modal"
                modalClassName="trct-modal"
                hideHeader={true}>
                <ExplenationFotoForTractable
                    secondaryCtaClicked={skipPhotoHandler}
                    mainCtaClicked={proceedWithPhotoHandler} />
            </RealtimeModal>
            <PageContainerCmp
                routePath={pageConfig.routePath}
                removeNextBtn
            >
                <>
                    <Section>
                        <PageTitle>{pageConfig.title}</PageTitle>
                        <Vspace></Vspace>
                        <TextDefault centered>{pageConfig.description}</TextDefault>
                    </Section>

                    <Section>
                        <Trtc_ZoneUrtoCmp
                            path={pageConfig.routePath}
                            mainImpactPoint={communication.ctpImpactPoint}
                            isMainImpactPoint={isMainImpactPoint}
                            zoneUrto={zoneUrto}
                            setZoneUrto={setZoneUrto}
                        />
                    </Section>

                    <NextButton style={{ textTransform: "none", margin: "0 2.5rem" }} disabled={nextBtnDisabled} onClick={() => isMainImpactPoint ? goToNextStepHandler() : clickGoNextHandler()}>{isMainImpactPoint ? "Conferma punto d'impatto" : "Conferma zone d'urto"}</NextButton>
                    <Vspace qty={2}></Vspace>
                    {!isMainImpactPoint && <SecondChoiseButton disabled={zoneUrto.length > 0} style={{ fontSize: "16px", color: "#0F3250" }} onClick={() => clickGoNextHandler(false)}>Non ci sono altre zone d'urto</SecondChoiseButton>}
                </>
            </PageContainerCmp>
        </>
    )
}

export default Trct_CtpZoneUrtoVeicoloPage